// @ts-nocheck
import React, {useState} from 'react';
import {ScrollView, View, StyleSheet} from 'react-native';
import Text from '../../components/Text';
import Navbar from '../../components/Navbar';
import Permissions from '../../components/Permissions';
import {UnitLink} from '../../@types/UnitLink';
import {deriveDirectoryFromState} from './utils';

const PermissionsScreen = ({navigation, route}) => {
  const unitLink: UnitLink = route.params.unitLink;
  const [unitPeopleState, setUnitPeopleState] = useState({
    ...unitLink,
  });

  // TODO: update this to use the new redux state
  function updateDirectoryInfo() {
    const directoryInfo = deriveDirectoryFromState(unitPeopleState);
    console.log('id', unitPeopleState.id);
    console.log('directoryInfo', directoryInfo);
    // dispatch(UpdatePeopleLink(unitPeopleState.id, directoryInfo));
  }

  const handlePermissionsToggle = permissions => {
    const resourcePermissions = {};
    permissions.forEach(permission => {
      resourcePermissions[permission.title.toLowerCase() + 'Permission'] =
        permission.permissions.map(perm => (perm.value ? '1' : '0')).join('');
    });
    setUnitPeopleState({
      ...unitPeopleState,
      ...resourcePermissions,
    });
  };

  return (
    <View style={styles.container}>
      <Navbar
        navigation={navigation}
        title={`Permissions for unit ${
          unitLink.unitNickname ? unitLink.unitNickname : unitLink.unit.unitName
        }`}
      />
      <>
        <ScrollView
          style={styles.scrollView}
          showsVerticalScrollIndicator={false}>
          <Permissions
            initialPeopleState={unitPeopleState}
            updateParentState={childState => {
              setUnitPeopleState({
                ...childState,
                firstName: unitPeopleState.firstName,
                lastName: unitPeopleState.lastName,
                city: unitPeopleState.city,
                zip: unitPeopleState.zip,
                state: unitPeopleState.state,
              })
            }
            }
            isEditMode={false}
          />
          {/* <Button
          onPress={updateDirectoryInfo}
          style={[styles.button, {backgroundColor: '#007bff'}]}
          isLoadingText="updating in ...">
          Update
        </Button> */}
          <Text>Button here</Text>
        </ScrollView>
      </>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginBottom: 16,
  },
  scrollView: {
    marginHorizontal: 8,
    paddingVertical: 16,
  },
  button: {
    marginHorizontal: 8,
    marginVertical: 16,
  },
});

export default PermissionsScreen;
